import { Component, OnInit } from "@angular/core";
import { PolicyService } from "../../../service/policy.service";
import { environment } from "../../../../environments/environment";
import { LocalStorageService } from "angular-2-local-storage";
import { AuthorizedApps } from "../../../enum/shared/authorized-apps.enum";
import { SearchPoItemModel } from "../../../model/builk/po-item/search-poitem.model";
import { PoItemService } from "../../../service/api/builk/poitem.service";
import { PoItemListModel } from "../../../model/builk/po-item/poitem-list.model";
import { PoItemModel } from "../../../model/builk/po-item/poitem.model";
import { SortType } from "../../../enum/builk/user-manager/sort-type";
import { SortCompanyModel } from "../../../model/builk/company-manage/company-sort";

@Component({
    selector: "bo-builk-po-item",
    templateUrl: "./po-item.component.html",
    styleUrls: ["./po-item.component.scss"]
})

export class PoItemComponent implements OnInit {

    constructor(
        private readonly policyService: PolicyService,
        private readonly localStorageService: LocalStorageService,
        private readonly poItemService: PoItemService
    ) { }

    getPoItem: SearchPoItemModel = new SearchPoItemModel();
    poItemResult: PoItemListModel = new PoItemListModel();
    countryList = new Array<string>();
    poItemList: Array<PoItemModel> = new Array<PoItemModel>();

    // Pagination
    page: number = 1;
    limit: number = 50;
    countAll: number = 0;
    lastPage: number = 1;

    // Search
    searchPoiItem: string;
    searchCompanyName: string;
    searchSupplierName: string;
    searchPoiUnit: string;
    searchDeliveryProvince: string;
    searchPoCredit: string;
    searchCostCode: string;
    searchDateFrom: string;
    searchDateTo: string;
    showAdvanceSearch: boolean;
    click = 0;

    sortCol: string = "create_date";
    sortType: number = SortType.DESC;

    public loading = false;

    ngOnInit(): void {
        this.loading = true;
        this.setPoItemList();
    }

    setPoItemList(): void {
        this.loading = true;
        this.getPoItem.page = ((this.page - 1) * 50) + 1;
        this.getPoItem.limit = this.limit;
        this.getPoItem.sortCol = this.sortCol;
        this.getPoItem.sortType = this.sortType;

        // Start of Get country list from user policy
        this.policyService.getUserPolicy(environment.firebaseConfig.policyCollection,
            "userEmail",
            this.localStorageService.get<string>("userEmail"))
            .subscribe(response => {
                this.loading = true;
                if (response.length > 0) {
                    const authorizedApp = response[0].authorizedApps.find(f => f.appName === AuthorizedApps.Builk);
                    if (authorizedApp !== undefined) {
                        this.countryList = authorizedApp.country;
                        this.getPoItem.culture = this.countryList.join(",");
                    }
                } // End of Get country list from user policy
                this.getPoItem.email = this.localStorageService.get<string>("userEmail");

                this.poItemService.getPoItemBackOffice(this.getPoItem)
                    .subscribe(
                        res => {
                            this.loading = true;
                            this.poItemResult = res;
                            this.poItemList = this.poItemResult.sourceData;
                            this.countAll = this.poItemResult.totalCount;
                            this.lastPage = Math.ceil((this.poItemResult.totalCount) / (this.limit));
                            this.loading = false;
                        }
                    );
                // this.loading = false;
            });
    }

    searchPoItem(): void {
        this.getPoItem.searchPoiItem = this.searchPoiItem;
        this.getPoItem.searchCompanyName = this.searchCompanyName;
        this.getPoItem.searchSupplierName = this.searchSupplierName;
        this.getPoItem.searchPoiUnit = this.searchPoiUnit;
        this.getPoItem.searchDeliveryProvince = this.searchDeliveryProvince;
        this.getPoItem.searchPoCredit = this.searchPoCredit;
        this.getPoItem.searchCostCode = this.searchCostCode;
        this.getPoItem.searchDateFrom = this.searchDateFrom;
        this.getPoItem.searchDateTo = this.searchDateTo;
        this.page = 1;
        this.setPoItemList();
    }

    backPage(): void {
        if (this.page > 1) {
            this.page--;
            this.setPoItemList();
        }
    }

    nextPage(): void {
        if (this.page < this.lastPage) {
            this.page++;
            this.setPoItemList();
        }
    }

    goTofirstPage(): void {
        if (this.page > 1) {
            this.page = 1;
            this.setPoItemList();
        }
    }

    goTolastPage(): void {
        if (this.page < this.lastPage) {
            this.page = this.lastPage;
            this.setPoItemList();
        }
    }

    reload(event: boolean): void {
        this.setPoItemList();
    }

    onSelectDocDateFrom(event: string): void {
        this.searchDateFrom = event;
    }

    onSelectDocDateTo(event: string): void {
        this.searchDateTo = event;
    }

    onShown(click: number): void {
        this.showAdvanceSearch = click % 2 === 0 ? true : false;
        this.click++;
    }

    // sort user list
  sortList(event: SortCompanyModel): void {
    this.loading = true;
    this.sortCol = event.sortCol;
    this.sortType = event.sortType;
    this.setPoItemList();
  }
}
